<div>
  @if (label) {
    <div class="label" [ngClass]="{ 'text-danger': error }">
      {{ label }}
      @if (isRequired) {
        <span>*</span>
      }
    </div>
  }
  <ng-select
    #select
    [(ngModel)]="input"
    [ngClass]="{ 'dropdown-error': error, 'transparent-bg': isTransparent, 'dropdown-vertical': isVertical }"
    [items]="items"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [clearable]="clearable"
    placeholder="{{ placeholder }}"
    class="{{ customClass }} dropdown-select [&_.ng-value-container]:min-w-0"
    [trackByFn]="trackByFn"
    (change)="onchange($event)"
    (remove)="onRemove($event)"
    (clear)="onClear()"
    (close)="onClose()"
    (open)="onOpen()"
    [multiple]="multiple"
    [searchable]="searchable"
    [disabled]="disabled"
    [closeOnSelect]="closeOnSelect"
    [addTag]="addTag"
    [addTagText]="addTagText"
    (scrollToEnd)="infiniteScroll()"
    (search)="onSearch($event)"
    [dropdownPosition]="dropdownPosition"
    [loading]="loading"
    [notFoundText]="notFoundText"
    [clearAllText]="clearAllText"
    [typeToSearchText]="typeToSearch"
    loadingText="{{ 'loading' | translate }}"
    [appendTo]="isAppendToBody ? 'body' : ''"
  >
    @if (selectAll) {
      <ng-template ng-header-tmp>
        <input
          [ngClass]="{ 'transparent-bg': isTransparent }"
          class="checkbox-select"
          type="checkbox"
          id="selectAllOption"
          name="selectAll"
          [(ngModel)]="isSelectAll"
          (ngModelChange)="toggleSelectAll($event)"
        />
        <label for="selectAllOption" class="cursor-pointer">{{ 'select_all' | translate }}</label>
      </ng-template>
    }

    <ng-template ng-label-tmp let-item="item" let-item$="item$" let-index="index">
      {{ isTranslate ? (item[bindLabelOption] | translate) : item[bindLabelOption] }}
    </ng-template>
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of getSlices(items, maxViewElements); track item) {
        <div class="w-full min-w-0 max-w-full">
          @if (isTranslate) {
            <app-chip class="block min-w-0 max-w-full" [isClose]="true" [noWrap]="true" (onChangeClose)="clear(item)">
              @if (optionColorField && item[optionColorField]) {
                <span class="mr-1.5 inline-block h-3 w-3 shrink-0 rounded-full" [style.background-color]="item[optionColorField]"></span>
              }
              @if (isAvatar) {
                <app-avatar
                  class="mr-1.5 shrink-0"
                  size="18px"
                  [url]="item['img_url'] || undefined"
                  [title]="item[bindLabelOption]"
                  [isPhotoGallery]="false"
                />
              } @else if (hasImg) {
                <img [src]="item['img_url']" class="chip-img" />
              }
              <span class="block min-w-0 flex-1 truncate">{{ item[bindLabelOption] | translate }}</span>
            </app-chip>
          }
          @if (!isTranslate) {
            <app-chip class="block min-w-0 max-w-full" [isClose]="true" [noWrap]="true" (onChangeClose)="clear(item)">
              @if (optionColorField && item[optionColorField]) {
                <span class="mr-1.5 inline-block h-3 w-3 shrink-0 rounded-full" [style.background-color]="item[optionColorField]"></span>
              }
              @if (isAvatar) {
                <app-avatar
                  class="mr-1.5 shrink-0"
                  size="18px"
                  [url]="item['img_url'] || undefined"
                  [title]="item[bindLabelOption]"
                  [isPhotoGallery]="false"
                />
              } @else if (hasImg) {
                <img [src]="item['img_url']" class="chip-img" />
              }
              <span class="block min-w-0 flex-1 truncate">{{ item[bindLabelOption] }}</span>
            </app-chip>
          }
        </div>
      }

      @if (items.length > maxViewElements) {
        <div class="shrink-0">
          <app-chip>+{{ items.length - maxViewElements }}</app-chip>
        </div>
      }
    </ng-template>

    @if (isHasActions) {
      <ng-template ng-header-tmp>
        @for (action of actions; track action; let i = $index) {
          <div id="action" class="action-click cursor-pointer text-dark" (click)="actionClick(action.value)">
            <div class="px-2 d-flex align-items-center">
              @if (action.icon) {
                <app-icon class="me-2">
                  {{ action.icon }}
                </app-icon>
              }
              <label class="cursor-pointer py-2" for="action">
                {{ action.translate ? (action.label | translate) : action.label }}
              </label>
            </div>
            @if (action !== actions.at(-1)) {
              <mat-divider></mat-divider>
            }
          </div>
        }
      </ng-template>
    }

    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      <div class="flex min-w-0 items-center gap-2">
        @if (optionColorField && item[optionColorField]) {
          <span class="h-3 w-3 shrink-0 rounded-full" [style.background-color]="item[optionColorField]"></span>
        }
        @if (isAvatar) {
          <app-avatar
            class="shrink-0"
            size="24px"
            [url]="item['img_url'] || undefined"
            [title]="item[bindLabelOption]"
            [isPhotoGallery]="false"
          />
        } @else if (hasImg) {
          <img [src]="item['img_url']" class="h-6 w-6 shrink-0 rounded-full object-cover" />
        }
        <span class="min-w-0 flex-1 truncate">{{ isTranslate ? (item[bindLabelOption] | translate) : item[bindLabelOption] }}</span>
      </div>
    </ng-template>
  </ng-select>
</div>
